/** Human labels for Inbox / peeks — plan/22 · plan/50. */

const LABELS: Record<string, string> = {
  mention: "Mention",
  approval_pending: "Approval",
  assigned: "Assigned",
};

export function notificationTypeLabel(type: string): string {
  const key = type.trim().toLowerCase();
  if (LABELS[key]) return LABELS[key]!;
  if (!key) return "Message";
  return key
    .split(/[_\s]+/)
    .filter(Boolean)
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join(" ");
}
